import type { ComponentType } from 'react';
import { Card, Flex, Box, Text } from '@radix-ui/themes';

export interface PickupTileData {
  icon: ComponentType;
  color: string;
  title: string;
  subtitle: string;
  prompt: string;
}

interface PickupTileProps {
  tile: PickupTileData;
  onClick: () => void;
}

export function PickupTile({ tile, onClick }: PickupTileProps) {
  const Icon = tile.icon;

  return (
    <Card size="2" style={{ cursor: 'pointer' }} onClick={onClick}>
      <Flex direction="column" gap="2">
        <Box>
          <Flex
            align="center"
            justify="center"
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              backgroundColor: `var(--${tile.color}-a3)`,
              color: `var(--${tile.color}-11)`,
            }}
          >
            <Icon />
          </Flex>
        </Box>
        <Text size="2" weight="bold">
          {tile.title}
        </Text>
        <Text size="1" color="gray">
          {tile.subtitle}
        </Text>
      </Flex>
    </Card>
  );
}
